import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
        iframeContainer: {
            position: 'relative',
            height: 0,
            paddingBottom: '56.25%'
        },
        iframe: {
            position: 'absolute',
            top: 0,
            left: 0,
            border: 0,
            width: '100%',
            height: '100%',
        },
    }));

export type PanelVideoProps = PanelVideoDto;
type Props = PanelVideoProps;

const PanelVideo: FC<Props> = ({  Video: { Id, Provider } }) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            <div className={cls.iframeContainer}>
                {Provider === "youtube" &&
                    <iframe
                        className={cls.iframe}
                        src={`http://www.youtube.com/embed/${Id}?rel=0`}
                    />
                }
                {Provider === "vimeo" &&
                    <iframe
                        className={cls.iframe}
                        src={`http://player.vimeo.com/video/${Id}?title=0&byline=0&portrait=0`}
                    />}
            </div>
        </div>
    );
}

export default PanelVideo;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelVideo.tsx